import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import PrivateRoutes from "./Privateroutes";

import Login from "../pages/Login";
import Home from "../pages/Administrador/Home";
import Administradores from "../pages/Administrador/Administradores";
import BuyerPage from "../pages/Administrador/Buyer";
import BuyerAbas from "../pages/Administrador/Buyer/BuyerAbas";
import AdministradorForm from "../pages/Administrador/Administradores/AdministradorForm";
import Seller from "../pages/Administrador/Seller/DadosCadastrais/";
import SellerAbas from "../pages/Administrador/Seller/SellerAbas";

import Oportunidade from "../pages/Administrador/Oportunidade";
import EditarOportunidade from "../pages/Administrador/Oportunidade/EditarOportunidade";

import PerfilDadosCadastraisSeller from "../pages/PerfilSeller/DadosCadastrais";
import PerfilSellerCd from "../pages/PerfilSeller/CD";
import PerfilSellerFormCd from "../pages/PerfilSeller/CD/FormCd";
import PerfilSellerFilial from "../pages/PerfilSeller/Filial";
import PerfilSellerFormFilial from "../pages/PerfilSeller/Filial/FormFilial";
import PerfilSellerUsuario from "../pages/PerfilSeller/Usuario";
import PerfilSellerFormUsuario from "../pages/PerfilSeller/Usuario/FormUsuario";
import PerfilSellerRemuneracaoGreener from "../pages/PerfilSeller/RemuneracaoGreener/RemuneracaoForm";
import ImportacaoOportunidade from "../pages/Administrador/Oportunidade/ImportarOportunidade";
import PerfilSellerOportunidade from "../pages/PerfilSeller/Oportunidade";
import PerfilSellerEditarOportunidade from "../pages/PerfilSeller/Oportunidade/EditarOportunidade";
import PerfilSellerImportacaoOportunidade from "../pages/PerfilSeller/Oportunidade/Importacao";
import PerfilSellerCategoriaProduto from "../pages/PerfilSeller/Produtos";
import PerfilSellerProdutoForm from "../pages/PerfilSeller/Produtos/FormProduto";
import ImportacaoProdutoSeller from "../pages/PerfilSeller/Produtos/ImportarProdutosSeller";
import PerfilBuyerResumoOportunidade from "../pages/Buyer/ResumoOportunidade";
import GestaoPedidos from "../pages/Administrador/gestaoPedidos";
import ProdutoPDF from "../pages/Administrador/Oportunidade/EditarOportunidade/produtoPDF";
import EditarGestaoPedidos from "../pages/Administrador/gestaoPedidos/EditarGestaoPedidos";
import Pedido from "../pages/Pedido";
import Configuracoes from "../pages/Configuracoes";
/* import FormCdSeller from '../pages/Administrador/Seller/CadastrosCd/FormCdSeller' */

export default () => (
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={Login} />

      <Route
        path="/buyer/:id"
        exact
        component={PerfilBuyerResumoOportunidade}
      />

      <PrivateRoutes path="/home" exact component={Home} />

      {/* Perfil Adminsitrador */}

      {/* Cadastros */}
      <PrivateRoutes
        path="/admin/administradores"
        exact
        component={Administradores}
      />
      <PrivateRoutes
        path="/admin/administrador/cadastro"
        exact
        component={AdministradorForm}
      />
      <PrivateRoutes
        path="/admin/administrador/:userId"
        exact
        component={AdministradorForm}
      />
      <PrivateRoutes path="/admin/buyers" exact component={BuyerPage} />
      <PrivateRoutes path="/admin/buyer/cadastro" exact component={BuyerAbas} />
      <PrivateRoutes
        path="/admin/buyer/:idEmpresa"
        exact
        component={BuyerAbas}
      />
      <PrivateRoutes path="/admin/sellers" exact component={Seller} />
      <PrivateRoutes
        path="/admin/seller/cadastro"
        exact
        component={SellerAbas}
      />
      <PrivateRoutes
        path="/admin/seller/:idEmpresa"
        exact
        component={SellerAbas}
      />
      <PrivateRoutes
        path="/admin/seller/:idEmpresa/editar/:idCdSeller"
        exact
        component={SellerAbas}
      />

      {/* Oportunidade */}
      <PrivateRoutes path="/oportunidade" exact component={Oportunidade} />
      <PrivateRoutes
        path="/oportunidade/cadastro"
        exact
        component={EditarOportunidade}
      />
      <PrivateRoutes
        path="/oportunidade/editar/:id"
        exact
        component={EditarOportunidade}
      />
      <PrivateRoutes
        path="/oportunidade/importacao/"
        exact
        component={ImportacaoOportunidade}
      />

      {/* Fim Perfil Administrador */}

      {/* Perfil Seller */}
      <PrivateRoutes
        path="/seller/empresa"
        exact
        component={PerfilDadosCadastraisSeller}
      />
      <PrivateRoutes
        path="/seller/filial-cd"
        exact
        component={PerfilSellerCd}
      />
      <PrivateRoutes
        path="/seller/filial-cd/cadastro"
        exact
        component={PerfilSellerFormCd}
      />
      <PrivateRoutes
        path="/seller/filial-cd/:id"
        exact
        component={PerfilSellerFormCd}
      />
      <PrivateRoutes
        path={"/seller/filial"}
        exact
        component={PerfilSellerFilial}
      />
      <PrivateRoutes
        path={"/seller/filial/cadastro"}
        exact
        component={PerfilSellerFormFilial}
      />
      <PrivateRoutes
        path={"/seller/filial/:id"}
        exact
        component={PerfilSellerFormFilial}
      />
      <PrivateRoutes
        path={"/seller/usuario"}
        exact
        component={PerfilSellerUsuario}
      />
      <PrivateRoutes
        path={"/seller/usuario/cadastro"}
        exact
        component={PerfilSellerFormUsuario}
      />
      <PrivateRoutes
        path={"/seller/usuario/:id"}
        exact
        component={PerfilSellerFormUsuario}
      />
      <PrivateRoutes
        path={"/seller/remuneracao"}
        exact
        component={PerfilSellerRemuneracaoGreener}
      />
      <PrivateRoutes
        path={"/seller/oportunidade"}
        exact
        component={PerfilSellerOportunidade}
      />
      <PrivateRoutes
        path={"/seller/oportunidade/cadastro"}
        exact
        component={PerfilSellerEditarOportunidade}
      />
      <PrivateRoutes
        path={"/seller/oportunidade/editar/:id"}
        exact
        component={PerfilSellerEditarOportunidade}
      />
      <PrivateRoutes
        path={"/seller/oportunidade/importacao"}
        exact
        component={PerfilSellerImportacaoOportunidade}
      />
      <PrivateRoutes
        path={"/produto"}
        exact
        component={PerfilSellerCategoriaProduto}
      />
      <PrivateRoutes
        path={"/produto/cadastro"}
        exact
        component={PerfilSellerProdutoForm}
      />
      <PrivateRoutes path={"/produto/pdf"} exact component={ProdutoPDF} />
      <PrivateRoutes
        path={"/produto/editar/:id"}
        exact
        component={PerfilSellerProdutoForm}
      />
      <PrivateRoutes
        path={"/produto/importacao"}
        exact
        component={ImportacaoProdutoSeller}
      />
      <PrivateRoutes path={"/gestaoPedidos"} exact component={GestaoPedidos} />
      <PrivateRoutes
        path={"/gestaoPedidos/editar/:id"}
        exact
        component={EditarGestaoPedidos}
      />
      
      {/* Configurações */}
      <PrivateRoutes
        path={"/configuracoes"}
        exact
        component={Configuracoes}
      />
      {/* Fim Perfil Seller */}
    </Switch>
  </BrowserRouter>
);
